var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8557 2C12.1021 2 9.85359 2.48481 8.1 3.8C7.19835 4.47624 5.64268 6.14135 4.25071 7.72313C3.56959 8.49713 2.9497 9.22549 2.49986 9.76064C2.42851 9.84552 2.36147 9.92551 2.29918 10L20 10V2H14.8557ZM20 12L2 12V20H20V12ZM0 21C0 21.5523 0.447715 22 1 22H21C21.5523 22 22 21.5523 22 21V1C22 0.447715 21.5523 0 21 0H14.8557C11.8979 0 9.14641 0.515195 6.9 2.2C5.80165 3.02376 4.10732 4.85865 2.74929 6.40187C2.05541 7.19037 1.4253 7.93076 0.968889 8.47374C0.74055 8.74538 0.555365 8.96799 0.427038 9.12297C0.362867 9.20047 0.312893 9.26108 0.278827 9.30248L0.239868 9.34989L0.226353 9.36638C0.226292 9.36646 0.226043 9.36676 1 10L0.226353 9.36638C0.0801746 9.54505 0 9.76916 0 10V21ZM18 15L16 15C15.4477 15 15 14.5523 15 14C15 13.4477 15.4477 13 16 13L18 13C18.5523 13 19 13.4477 19 14C19 14.5523 18.5523 15 18 15Z",
    fill: "#8B8C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/Door.e8e85e21.svg";
export { ForwardRef as ReactComponent };